/**
 * One sentence for a stop request the server turned down, shown by the sidebar's
 * Stop button when `onStop` rejects (SYD-2443).
 *
 * It is deliberately not `formatWorkflowErrorMessage`: that function describes a run
 * that failed, and here the run is still going. Its `deadline-exceeded` branch would
 * tell the operator to check the communication log before retrying, and its
 * contentless branch would say the workflow failed — both describe the wrong thing.
 *
 * The refusal's own words are appended only when the server sent readable ones. A
 * message that is empty, or that is just the status code spelled back, says nothing
 * an operator can act on, so the lead sentence stands alone.
 */

import { readCallableError } from './readCallableError';

const formatStopRefusalMessage = (error: unknown): string => {
  const { code, message } = readCallableError(error);
  const contentless = !!code && (message === '' || message.toLowerCase().replace(/_/g, '-') === code);
  const reason = message !== '' && !contentless
    ? ` ${/[.!?]$/.test(message) ? message : `${message}.`}`
    : '';

  return `The run could not be stopped and is still running.${reason}`;
};

export default formatStopRefusalMessage;
